import { InputHTMLAttributes } from 'react'
import { Controller, FieldValues } from 'react-hook-form'
import { ControlledFieldProps } from '@/root/shared-types/form/controlledField'
import cn from 'classnames'

type ControlledInputProps<T extends FieldValues> = ControlledFieldProps<T> &
  InputHTMLAttributes<HTMLInputElement> & { error?: boolean }

export const ControlledInput = <T extends FieldValues>({
  name,
  control,
  rules,
  disabled,
  error,
  className,
  ...rest
}: ControlledInputProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <input
          disabled={disabled}
          {...field}
          {...rest}
          className={cn(
            'text-neutral-darker placeholder:text-neutral-medium-lighter h-9 w-full rounded-lg border bg-white px-2.5 text-base placeholder:text-base focus:outline-none',
            error ? 'border-error focus:border-error' : 'border-neutral-medium-lighter focus:border-primary-base',
            disabled && 'opacity-50',
            className
          )}
        />
      )}
    />
  )
}
